// packages import
import { Button, CircularProgress, DialogActions, Typography } from "@mui/material"
import { FC, useContext } from "react"
// component import
import { Alert } from "../../common/Alert"
import { CustomModal } from "../../common/CustomModal"
// others
import { useRemoveExternalUserFromCourtMutation } from "../../../../generated"
import { CANCEL, SOMETHING_WENT_WRONG } from "../../../constants"
import { AppContext } from "../../../context"
import { ActionType } from "../../../context/AppContextReducer"
import { RemoveJudgeModalProps } from "../../../interfaceTypes"
import { titleize } from "../../../utils"

export const RemoveJudgeFromCourt: FC<RemoveJudgeModalProps> = ({ isOpen, currentExternalUser, courtId, reFetchCourt, courtName, refetchExistingJudges }) => {
  const { dispatch } = useContext(AppContext)
  const { id: externalUserId, firstName, lastName } = currentExternalUser || {}
  const fullName = `${firstName} ${lastName}`

  const handleCloseModal = () => {
    dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isOpen })
  }

  const [removeJudge, { loading }] = useRemoveExternalUserFromCourtMutation({
    variables: {
      removeExternalUserFromCourt: {
        courtId,
        externalUserId
      }
    },

    onError() {
      Alert.error(SOMETHING_WENT_WRONG)
    },

    onCompleted(data) {
      const { removeExternalUserFromCourt } = data || {}

      if (removeExternalUserFromCourt) {
        const { response } = removeExternalUserFromCourt
        const { status } = response || {}

        if (status === 200) {
          reFetchCourt && reFetchCourt()
          refetchExistingJudges && refetchExistingJudges()
          dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
          dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isOpen })
          Alert.success('Judge removed from court')
        }
      }
    }
  })

  const handleRemoveJudge = async () => {
    if (!loading) {
      await removeJudge({
        variables: {
          removeExternalUserFromCourt: {
            courtId,
            externalUserId
          }
        }
      })
    }
  }

  return (
    <CustomModal title='Remove judge from court' isOpen={isOpen} handleClose={handleCloseModal}>
      <Typography variant="body1">{`You are about to remove the judge ${fullName}  from court:`}</Typography>
      <Typography variant="body1" fontWeight={500}>{titleize(courtName || '')}</Typography>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap', gap: '5px' }}>
        <Button onClick={handleCloseModal} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

        <Button
          disabled={loading}
          onClick={handleRemoveJudge}
          color='primary'
          variant="contained"
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
          aria-label='remove judge'
        >
          Remove Judge
        </Button>
      </DialogActions>
    </CustomModal>
  )
}